import { render, staticRenderFns } from "./treeselect.vue?vue&type=template&id=815d38c4&scoped=true&"
import script from "./treeselect.vue?vue&type=script&lang=js&"
export * from "./treeselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "815d38c4",
  null
  
)

export default component.exports